<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>电销短信/AI电销</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.task_name" autocomplete="off" maxlength="30" placeholder="任务名称"
							clearable @input="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.task_status" placeholder="请选择任务状态" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchStatusClearInput">
							<el-option v-for="(value,key,index) in statusDict" :key="key" :label="value" :value="key" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoqu_id" placeholder="请选择小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchXiaoquClearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增任务</el-button>
				
				<el-switch style="margin-left: 150px;" v-model="aiSwitch" active-value="1" active-color="#13ce66" active-text="开启电销" inactive-text="关闭电销"
					inactive-value="0" @change="changeAction"></el-switch>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="task_name" label="任务名称" align="center" width="180" />
			<el-table-column prop="xiaoqu_id" label="任务小区" align="center">
				<template slot-scope="scope">
					<div>
						{{findXiaoqu(scope.row.xiaoqu_id)}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="flow_name" label="话术流程" align="center" />
			<el-table-column prop="sms_strategy_name" label="短信策略" align="center" />
			<el-table-column prop="task_start_day" label="开始时间" align="center" />
			<el-table-column prop="" label="拨打时段" align="center" width="160">
				<template slot-scope="scope">
					<div>
						{{scope.row.task_period_start + ' - ' + scope.row.task_period_end}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="已拨打数" align="center">
				<template slot-scope="scope">
					<div>
						{{scope.row.call_size + '/' + scope.row.phones_size}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="connected_size" label="接通数" align="center" />
			<el-table-column prop="call_connected_ratio" label="接通率" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.call_connected_ratio + '%'}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="status_name" label="任务状态" align="center" />
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="任务名称" prop="task_name">
							<el-input v-model="form.task_name" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择小区" prop="xiaoqu_id">
							<el-select v-model="form.xiaoqu_id" style="width: 100%;" placeholder="请选择小区" clearable
								size="small" filterable @change="xiaoquSelectChange" @clear="addClearXiaoquInput">
								<el-option v-for="item in regionArr" :key="item.xiaoqu_id" :label="item.xiaoqu_name"
									:value="item.xiaoqu_id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择话术流程" prop="flow_name">
							<el-select v-model="form.flow_name" style="width: 100%;" placeholder="请选择话术流程" clearable
								size="small" filterable @change="flowSelectChange" @clear="addClearHuashuInput">
								<el-option v-for="item in flows" :key="item.flow_no" :label="item.flow_name"
									:value="item.flow_name" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="话术语音" prop="script_audio_url">
							<!-- <el-upload class="avatar-uploader el-upload--text" disabled :action="uploadImgUrl"
								:show-file-list="false" :on-success="handleVideoSuccess"
								:before-upload="beforeUploadVideo" :on-progress="uploadVideoProcess" :headers="headers"> -->
								<!-- <div class="avatar-wrapper">
									<i v-if="form.script_audio_url" class="el-icon-close" @click.stop="removeAudio"></i>
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</div> -->
								<audio v-if="form.script_audio_url" controls :src="form.script_audio_url"></audio>
								<!-- <i v-if="form.script_audio_url" class="el-icon-close" @click.stop="removeAudio"></i> -->
								<!-- <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent"
									style="margin-top: 30px"></el-progress> -->
							<!-- </el-upload> -->
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="话术内容" prop="flow_script_content">
							<el-input v-model="form.flow_script_content" type="textarea" disabled autocomplete="off"
								placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择短信策略" prop="sms_strategy_name">
							<el-select v-model="form.sms_strategy_name" style="width: 100%;" placeholder="请选择短信策略" clearable
								size="small" filterable @change="smsSelectChange" @clear="addClearSmsInput">
								<el-option v-for="item in smsList" :key="item.strategy_no" :label="item.strategy_name"
									:value="item.strategy_name" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="短信内容" prop="sms_strategy_content">
							<el-input v-model="form.sms_strategy_content" disabled type="textarea" autocomplete="off"
								placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="开始时间" prop="task_start_day">
							<el-date-picker v-model="form.task_start_day" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期时间" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="拨打时段" prop="task_period">
							<el-time-picker is-range arrow-control v-model="form.task_period" value-format="HH:mm:ss" range-separator="至"
								start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" @input="changeDate">
							</el-time-picker>
						</el-form-item>
					</el-col>
					<div v-if="title=='新增'">
						<el-col :span="24">
							<el-form-item label="选择电话" prop="" required="true">
								<el-input v-model="form.mobile_count" label="个" disabled autocomplete="off"
									placeholder="" class="right-aligned-input">
									<el-button slot="append" type="primary" @click="showPhoneSelect">选 择</el-button>
								</el-input>
							</el-form-item>
						</el-col>
					</div>
					<div v-else>
						<el-col :span="24">
							<el-form-item label="电话总数" prop="">
								<el-input v-model="form.phones_size" autocomplete="off" placeholder="" disabled />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="已拨打数" prop="">
								<el-input v-model="form.call_size" autocomplete="off" placeholder="" disabled />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="接通数" prop="">
								<el-input v-model="form.connected_size" autocomplete="off" placeholder="" disabled />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="接通率" prop="">
								<el-input v-model="form.call_connected_ratio" autocomplete="off" placeholder=""
									disabled />
							</el-form-item>
						</el-col>
					</div>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="筛选电话" :visible.sync="selectCustomer" :close-on-click-modal="false" width="60%"
			class="dialogHeight2 global-dialog-position" :before-close="closeSelectCustomer" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<div v-for="tag in tags" :key="tag.title">
				<el-checkbox :indeterminate="tag.isIndeterminate" v-model="tag.checkAll"
					@change="handleCheckAllChange($event,tag)">{{tag.title}}</el-checkbox>

				<el-checkbox-group v-model="tag.selectTags" @change="handleGroupCheckChange($event,tag)"
					style="margin-top: 10px;margin-bottom: 10px;">
					<el-checkbox-button v-for="dt in tag.dtos" :label="dt.name" :key="dt.id"></el-checkbox-button>
				</el-checkbox-group>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmPhoneSelect">确 定</el-button>
				<el-button @click="closeSelectCustomer">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getAiCallList,
		addAiCall,
		editAiCall,
		getSmsList,
		getStatusList,
		getFlowList,
		getPhoneFilterList,
		getPhoneCountList,
		querySmsStatus,
		switchSmsStatus
	} from "../../api/aiCall";
	import {
	  deleteImg,
	} from "../../api/homePage";
	import {
		getcarList
	} from "../../api/garage";
	import {
		getCookie
	} from "../../utils/util";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getAiCallList,
					add: addAiCall,
					edit: editAiCall,
				},
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 规则验证
				rules: {
					task_name: [{
						required: true,
						message: "请输入任务名称",
						trigger: "blur"
					}],
					xiaoqu_id: [{
						required: true,
						message: "请选择小区",
						trigger: "change"
					}],
					flow_name: [{
						required: true,
						message: "请选择流程名称",
						trigger: "change"
					}],
					flow_script_content: [{
						required: true,
						message: "请输入话术内容",
						trigger: "blur"
					}],
					script_audio_url: [{
						required: true,
						message: "请上传音频",
						trigger: "change"
					}],
					sms_strategy_name: [{
						required: true,
						message: "请选择短信策略",
						trigger: "change"
					}],
					sms_strategy_content: [{
						required: true,
						message: "请输入短信内容",
						trigger: "blur"
					}],
					task_start_day: [{
						required: true,
						message: "请选择开始时间",
						trigger: "change"
					}],
					task_period: [{
						required: true,
						message: "请选择拨打时段",
						trigger: "change"
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					task_name: '',
					task_status: '',
					xiaoqu_id: ''
				},
				tableData: [],
				regionArr: [],
				selectCustomer: false,
				statusDict: {},
				flows: [],
				smsList: [],
				xiaoqu_id: 0,
				tags: [],
				videoFlag: false,
				videoUploadPercent: 0,
				nParams: null,
				aiSwitch: '0',
			};
		},
		watch: {
			"form.xiaoqu_id": function(newVal, oldVal) {
				if (newVal) {
					getPhoneFilterList({
						xiaoqu_id: newVal
					}).then((res) => {
						var list = res.data;
						list.forEach((item) => {
							item.isIndeterminate = false;
							item.checkAll = false;
							item.selectTags = [];
						});
						this.tags = list;
					});
				}
			}
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				console.log(this.regionArr)
			});
			getStatusList().then((res) => {
				this.statusDict = res.data;
			});
			getFlowList().then((res) => {
				this.flows = res.data;
			});
			getSmsList().then((res) => {
				this.smsList = res.data;
			});
			querySmsStatus({button_type:'aiCallButton'}).then((res)=>{
				if (res.code == 200) {
					this.aiSwitch = res.data.value
				}
			});
		},
		methods: {
			changeAction() {
				switchSmsStatus({button_type:'aiCallButton'}).then((res)=>{
					if (res.code == 200) {
						
					}else{
						this.aiSwitch = !this.aiSwitch;
					}
				});
			},
			xiaoquSelectChange(data) {
				this.$forceUpdate();
			},
			smsSelectChange(data) {
				this.$forceUpdate();
				let sms = this.smsList.find((flow)=> {
					return flow.strategy_name == data;
				});
				this.form.sms_strategy_no = sms.strategy_no;
				this.form.sms_strategy_content = sms.script_content;
			},
			flowSelectChange(data) {
				this.$forceUpdate();
				let flow = this.flows.find((flow)=> {
					return flow.flow_name == data;
				});
				this.form.flow_no = flow.flow_no;
				this.form.script_audio_url = flow.script_url;
				this.form.flow_script_content = flow.script_content;
			},
			searchStatusClearInput() {
				this.searchForm.task_status = '';
				this.searchChange();
			},
			searchXiaoquClearInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchChange();
			},
			clearSearchInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchForm.task_name = '';
				this.searchForm.task_status = '';
				this.searchChange();
			},
			addClearXiaoquInput() {
				this.form.xiaoqu_id = '';
			},
			addClearHuashuInput() {
				this.form.flow_no = '';
				this.form.flow_name = '';
			},
			addClearSmsInput() {
				this.form.strategy_no = '';
				this.form.sms_strategy_name = '';
			},
			changeDate(e) {
				this.$forceUpdate();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr.find(item => item.xiaoqu_id == xiaoqu_id);
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
			showPhoneSelect() {
				if (this.form.xiaoqu_id) {
					this.selectCustomer = true;
				} else {
					this.$message.info('请先选择小区');
				}
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log('行修改点击：', this.form);

				if (this.form.task_period_start && this.form.task_period_end) {
					this.form.task_period = [this.form.task_period_start, this.form.task_period_end];
				}

				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				console.log('===================form:',this.form)
				if (this.form.task_period.length == 2) {
					this.form.task_period_start = this.form.task_period[0];
					this.form.task_period_end = this.form.task_period[1];
				}
				
				if (this.title == '新增') {
					if (!this.form.mobile_count > 0) {
						this.$message.warning('请选择要拨打的电话');
						return;
					}
					
					this.form.phone_params = this.nParams;
				} else {
					
				}
				
				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					this.$message.error('提交失败');
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
			confirmPhoneSelect() {
				var params = {
					xiaoqu_id: this.form.xiaoqu_id
				};
				this.tags.forEach((tag) => {
					if (tag.selectTags.length) {
						if (!params[tag.title_key]) {
							params[tag.title_key] = [];
						}
						tag.dtos.forEach((dt) => {
							if (tag.selectTags.includes(dt.name)) {
								params[tag.title_key].push(dt.id);
							}
						});
					}
				});

				Object.keys(params).forEach((key) => {
					if (Array.isArray(params[key])) {
						params[key] = params[key].join(',')
					}
				});
				// console.log('===========================选择：',params)
				getPhoneCountList(params).then((res) => {
					if (res.data > 0) {
						this.nParams = params;
					}
					this.form.mobile_count = res.data;
					this.selectCustomer = false;
				}).catch((err) => {
					this.selectCustomer = false;
				});

			},
			// 关闭选择电话弹窗
			closeSelectCustomer() {
				this.selectCustomer = false;
			},
			handleVideoSuccess(res, file, list) {
				if (res.data && res.data.path) {
					this.form.script_audio_url = res.data.path;
					this.form.audio_id = res.data.id;
					this.$forceUpdate();
					this.videoFlag = false;
				}

				console.log('上传文件成功：', res);
			},
			// 验证视频格式
			beforeUploadVideo(file) {
				console.log('文件类型===================：', file)
				if (
					[
						"audio/mp3",
						"audio/mp4",
						"audio/mpeg",
						"audio/ogg",
						"audio/wav",
					].indexOf(file.type) === -1
				) {
					this.$message.error("请上传正确的音频格式");
					return false;
				}
			},
			// 上传进度显示
			uploadVideoProcess(event, file, fileList) {
				this.videoFlag = true;
				this.videoUploadPercent = Math.floor(event.percent);
			},
			removeAudio() {
				deleteImg(this.form.audio_id).then((res)=>{
					console.log('音频文件删除：',res);
					if (res.code == 200) {
						this.form.script_audio_url = null;
						delete this.form.audio_id;
						this.$forceUpdate();
					}
				});
			},
			handleCheckAllChange(val, tag) {
				if (val) {
					var stags = [];
					tag.dtos.forEach((item) => {
						stags.push(item.name);
					});
					tag.selectTags = stags;
				} else {
					tag.selectTags = [];
				}

				tag.isIndeterminate = false;

			},
			handleGroupCheckChange(value, tag) {
				let checkedCount = value.length;
				tag.checkAll = checkedCount === tag.dtos.length;
				tag.isIndeterminate = checkedCount > 0 && checkedCount < tag.dtos.length;
			}
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	/deep/ .right-aligned-input .el-input__inner {
		text-align: right;
	}

	/deep/ .right-aligned-input .el-input__suffix {
		right: 0;
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 18px;
		right: 28vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}


	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/actAICallSms/aiCall.vue